import { InjectionToken } from '@angular/core';
import { SupabaseClientOptions } from '@supabase/supabase-js';

export interface SupabaseConfig {
  supabaseUrl: string;
  supabaseKey: string;
  options?: SupabaseClientOptions<'public'>;
}

export const SUPABASE_CONFIG = new InjectionToken<SupabaseConfig>(
  'supabase.config'
);
